export const numberW = 25;
export const vendorW = 240;
export const descriptionW = 320;
export const usersW = 140;
export const rulesW = 120;
export const selectW = 15;
